// extracted by mini-css-extract-plugin
export default {"order_details":"OrderDetails_order_details__ctwat","btn_wrapper":"OrderDetails_btn_wrapper__31FIO"};